<template>
    <v-container fluid>
        <v-container fluid>
            <v-row class="py-0">
                <v-col cols="12" xl="6" class="title py-0">すべての送受信</v-col>
            </v-row>
        </v-container>
        <v-expansion-panels v-model="panel" multiple class="px-3 ma-0">
            <v-expansion-panel>
                <v-expansion-panel-header class="search-title py-2 px-2">検索条件</v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                    <v-container class="search-container pa-0">
                        <v-row no-gutters>
                            <div class="search-section my-1">
                                <div class="sear pr-5 my-1">
                                    <span class="search-status">
                                      状態: 
                                    </span>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.authorizer = searchItem.authorizer ? false : true" v-bind:class="{blur: searchItem.authorizer}">
                                      承認待ち
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.signature = searchItem.signature ? false : true" v-bind:class="{blur: searchItem.signature}">
                                      署名待ち
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.conclusion = searchItem.conclusion ? false : true" v-bind:class="{blur: searchItem.conclusion}">
                                      締結済み
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.rejection = searchItem.rejection ? false : true" v-bind:class="{blur: searchItem.rejection}">
                                      却下
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.error = searchItem.error ? false : true" v-bind:class="{blur: searchItem.error}">
                                      エラー
                                    </v-btn>
                                </div>
                                <div class="sear my-1">
                                    <span class="search-status">
                                      署名方式: 
                                    </span>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.sign_long = searchItem.sign_long ? false : true" v-bind:class="{blur: searchItem.sign_long}">
                                      電子署名
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.sign_light_timestamp = searchItem.sign_light_timestamp ? false : true" v-bind:class="{blur: searchItem.sign_light_timestamp}" style="width: 192px !important">
                                      電子サイン+タイムスタンプ
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.sign_light = searchItem.sign_light ? false : true" v-bind:class="{blur: searchItem.sign_light}">
                                      電子サイン
                                    </v-btn>
                                </div>
                            </div>
                        </v-row>
                        <v-row class="my-1">
                            <v-col xl="2" md="2" sm="12" xs="12" class="py-0" style="min-width: 300px;">
                                <v-row no-gutters>
                                    <v-col cols="auto" class="mr-auto">
                                        <span style="font-size: 13px">送信企業</span>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item">
                                        <v-icon 
                                            @mouseover="iconIndex = 1" 
                                            @mouseleave="iconIndex = 0" 
                                            @click="searchSenderMyCompany"
                                            :class="{searchicon: iconIndex == 1 || searchItem.sender_my_company == true}">
                                                mdi-home-account 
                                        </v-icon>
                                        <p class="icon-bubble">私の企業</p>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item mr-1">
                                        <v-icon 
                                            @mouseover="iconIndex = 2" 
                                            @mouseleave="iconIndex = 0" 
                                            @click="searchSenderOtherCompany"
                                            :class="{searchicon: iconIndex == 2 || searchItem.sender_other_company == true}">
                                                mdi-home
                                        </v-icon>
                                        <p class="icon-bubble">私以外の企業</p>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <select-component
                                        v-model="searchItem.sender_companies"
                                        :items="senderCompanies"
                                        @click:clear="searchItem.sender_my_company = false; searchItem.sender_other_company = false"
                                        return-object
                                        item-text="company_name"
                                        item-value="company_id"
                                    ></select-component>
                                </v-row>
                            </v-col>
                            <v-col xl="2" md="2" sm="12" xs="12" class="py-0" style="min-width: 250px;">
                                <v-row no-gutters>
                                    <v-col cols="auto" class="mr-auto">
                                        <span style="font-size: 13px">送信者</span>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item">
                                        <v-icon 
                                            @mouseover="iconIndex = 3" 
                                            @mouseleave="iconIndex = 0" 
                                            @click="searchCharge"
                                            :class="{searchicon: iconIndex == 3 || searchItem.charge == true}">
                                                mdi-account
                                        </v-icon>
                                        <p class="icon-bubble">私</p>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item mr-1">
                                        <v-icon 
                                            @mouseover="iconIndex = 4" 
                                            @mouseleave="iconIndex = 0" 
                                            @click="searchOtherCharge"
                                            v-model="searchItem.other_charge"
                                            :class="{searchicon: iconIndex == 4 || searchItem.other_charge == true}">
                                                mdi-account-remove
                                        </v-icon>
                                        <p class="icon-bubble">私以外</p>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <select-component
                                        v-model="searchItem.senders"
                                        :items="senders"
                                        @click:clear="searchItem.charge = false; searchItem.other_charge = false;"
                                        return-object
                                        item-text="sender_user_name"
                                        item-value="sender_email_address"
                                    ></select-component>
                                </v-row>
                            </v-col>
                            <v-col xl="2" md="2" sm="12" xs="12" class="py-0" style="min-width: 250px;">
                                <v-row no-gutters>
                                    <v-col cols="auto" class="mr-auto">
                                        <span style="font-size: 13px">次の確認者</span>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item">
                                        <v-icon 
                                            @mouseover="iconIndex = 5" 
                                            @mouseleave="iconIndex = 0" 
                                            @click="searchIConfirmer"
                                            :class="{searchicon: iconIndex == 5 || searchItem.i_confirmer == true}">
                                                mdi-account
                                        </v-icon>
                                        <p class="icon-bubble">私</p>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item mr-1">
                                        <v-icon 
                                            @mouseover="iconIndex = 6" 
                                            @mouseleave="iconIndex = 0" 
                                            @click="searchOtherConfirmer"
                                            :class="{searchicon: iconIndex == 6 || searchItem.other_confirmer == true}">
                                                mdi-account-remove
                                        </v-icon>
                                        <p class="icon-bubble">私以外</p>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <select-component
                                        v-model="searchItem.next_checkers"
                                        :items="nextChecker"
                                        @click:clear="searchItem.i_confirmer = false; searchItem.other_confirmer = false;"
                                        return-object
                                        item-text="next_confirm_user_name"
                                        item-value="next_confirm_email_address"
                                    ></select-component>
                                </v-row>
                            </v-col>
                            <v-col xl="2" md="2" sm="12" xs="12" class="py-0" style="min-width: 250px;">
                                <v-row no-gutters>
                                    <v-col cols="auto" class="mr-auto">
                                        <span style="font-size: 13px">契約先企業</span>
                                    </v-col>
                                    <v-col cols="auto" class="icon-item mr-1">
                                        <v-icon color="white">mdi-account</v-icon>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <select-component
                                        v-model="searchItem.to_contract_companies"
                                        :items="toContractCompanies"
                                    ></select-component>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-1">
                            <v-col xl="5" md="5" sm="12" xs="12" class="py-0 pr-2">
                                <badge-component tile color="unset">
                                    <label-component height="15" style="font-size: 13px">フリーワード</label-component>
                                </badge-component>
                                <text-field-component
                                  v-model="searchItem.keyword" 
                                  placeholder="フリーワードを入力"
                                ></text-field-component>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-container fluid class="contents">
            <v-row v-if="items.length > 0">
                <v-col no-gutters class="page-offset-col">
                     <page_offset_limit_component :total="total" :items_per_page="indexInfo.itemsPerPage" :page="indexInfo.page" style="font-size: 12px;"></page_offset_limit_component>
                </v-col>
                <v-col class="align-self-end" offset-sm="0" offset-xs="0">
                    <v-pagination
                        v-model="indexInfo.page"
                        :length="indexInfo.pageCount"
                    ></v-pagination>
                </v-col>
                <v-col class="text-right" style="min-width: 250px;" no-gutters>
                    <v-btn @click="itemSettingDialog = true" color="blue" class="white--text setting-btn">表示設定</v-btn>
                    <VueJsonToCsv :json-data="csvData" :csv-title="csvTitle" :labels="labels">
                        <v-btn @click="exportFiles" color="orange" class="white--text csv-btn">CSVエクスポート</v-btn>
                    </VueJsonToCsv>
                </v-col>
            </v-row>
            <v-data-table
                loading-text="読込中"
                :items="filterItems"
                :headers="filterHeaders"
                :page.sync="indexInfo.page"
                :items-per-page="indexInfo.itemsPerPage"
                @page-count="indexInfo.pageCount = $event"
                hide-default-footer
                no-data-text="データなし"
                @click:row="itemAction"
                sort-by="next_confirm_order"
                sort-desc
            >
                <template v-slot:item.next_confirm_order="{ value }">
                    <v-icon v-if="value">
                        mdi-email-outline
                    </v-icon>
                </template>
                <template v-slot:item.contract_name="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-if="item.is_confidential" style="border:1px solid red; border-radius: 2px; text-align: center; color: red; font-size: 11px;">親展</span>
                            <span
                            class="info-to"
                            v-bind="attrs"
                            v-on="on"
                            >
                                {{ item.contract_name }}
                            </span>
                        </template>
                        <span>{{ item.contract_name }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.contract_status="{ item }">
                    <span v-bind:class="[item.contract_status]">{{ getContractStatus(item) }}</span>
                </template> 
                <template v-slot:item.signature_method="{ item }">
                    {{ getSignatureMethodTextAbbreviation(item.signature_method) }}
                </template> 
                <template v-slot:item.close_date="{ item }">
                    {{ weekTimeFormat(item.close_date) }}
                </template> 
                <template v-slot:item.sender_send_datetime="{ item }">
                    {{ item.sender_send_datetime ? weekTimeFormat(item.sender_send_datetime) : '' }}
                </template> 
                <template v-slot:item.next_remind_send_datetime="{ item }">
                    {{ item.next_remind_send_datetime ? weekTimeFormat(item.next_remind_send_datetime) : '' }}
                </template> 
                 <template v-slot:item.antecedent_confirm_signature_datetime="{ item }">
                    {{item.antecedent_confirm_signature_datetime ? weekTimeFormat(item.antecedent_confirm_signature_datetime) : ''}}
                </template> 
                <template v-slot:item.antecedent_confirm_signature_status="{ item }">
                    {{item.antecedent_confirm_signature_status ? getSignatureStatus(item.antecedent_confirm_signature_status, item.antecedent_confirm_is_authorizer) : ''}}
                </template> 
                <template v-slot:item.next_confirm_role="{ item }">
                    {{ getIsAuthorizer(item.next_confirm_is_authorizer) }}
                </template> 
                <template v-slot:item.next_confirm_opening_status="{ item }">
                    {{item.next_confirm_opening_status ? getOpeningStatus(item.next_confirm_opening_status) : ''}}
                </template> 
                <template v-slot:item.next_confirm_expire="{ item }">
                    {{item.next_confirm_expire ? weekTimeFormat(item.next_confirm_expire) : ''}}
                </template> 
                <template v-slot:item.last_confirm_signature_datetime="{ item }">
                    {{item.last_confirm_signature_datetime ? weekTimeFormat(item.last_confirm_signature_datetime) : ''}}
                </template> 
                <template v-slot:item.destination_role_2="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_2) }}
                </template> 
                <template v-slot:item.destination_role_3="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_3) }}
                </template> 
                <template v-slot:item.destination_role_4="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_4) }}
                </template> 
                <template v-slot:item.destination_role_5="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_5) }}
                </template> 
                <template v-slot:item.destination_role_6="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_6) }}
                </template> 
                <template v-slot:item.destination_role_7="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_7) }}
                </template> 
                <template v-slot:item.destination_role_8="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_8) }}
                </template> 
                <template v-slot:item.destination_role_9="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_9) }}
                </template> 
                <template v-slot:item.destination_role_10="{ item }">
                    {{ getIsAuthorizer(item.is_authorizer_10) }}
                </template> 
                <template v-slot:item.signature_datetime_2="{ item }">
                    {{item.signature_datetime_2 ? weekTimeFormat(item.signature_datetime_2) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_3="{ item }">
                    {{item.signature_datetime_3 ? weekTimeFormat(item.signature_datetime_3) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_4="{ item }">
                    {{item.signature_datetime_4 ? weekTimeFormat(item.signature_datetime_4) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_5="{ item }">
                    {{item.signature_datetime_5 ? weekTimeFormat(item.signature_datetime_5) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_6="{ item }">
                    {{item.signature_datetime_6 ? weekTimeFormat(item.signature_datetime_6) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_7="{ item }">
                    {{item.signature_datetime_7 ? weekTimeFormat(item.signature_datetime_7) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_8="{ item }">
                    {{item.signature_datetime_8 ? weekTimeFormat(item.signature_datetime_8) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_9="{ item }">
                    {{item.signature_datetime_9 ? weekTimeFormat(item.signature_datetime_9) : ''}}
                </template> 
                <template v-slot:item.signature_datetime_10="{ item }">
                    {{item.signature_datetime_10 ? weekTimeFormat(item.signature_datetime_10) : ''}}
                </template> 
                <template v-slot:item.signature_status_2="{ item }">
                    {{item.signature_status_2 ? getSignatureStatus(item.signature_status_2, item.is_authorizer_2) : ''}}
                </template> 
                <template v-slot:item.signature_status_3="{ item }">
                    {{item.signature_status_3 ? getSignatureStatus(item.signature_status_3, item.is_authorizer_3) : ''}}
                </template> 
                <template v-slot:item.signature_status_4="{ item }">
                    {{item.signature_status_4 ? getSignatureStatus(item.signature_status_4, item.is_authorizer_4) : ''}}
                </template> 
                <template v-slot:item.signature_status_5="{ item }">
                    {{item.signature_status_5 ? getSignatureStatus(item.signature_status_5, item.is_authorizer_5) : ''}}
                </template> 
                <template v-slot:item.signature_status_6="{ item }">
                    {{item.signature_status_6 ? getSignatureStatus(item.signature_status_6, item.is_authorizer_6) : ''}}
                </template> 
                <template v-slot:item.signature_status_7="{ item }">
                    {{item.signature_status_7 ? getSignatureStatus(item.signature_status_7, item.is_authorizer_7) : ''}}
                </template> 
                <template v-slot:item.signature_status_8="{ item }">
                    {{item.signature_status_8 ? getSignatureStatus(item.signature_status_8, item.is_authorizer_8) : ''}}
                </template> 
                <template v-slot:item.signature_status_9="{ item }">
                    {{item.signature_status_9 ? getSignatureStatus(item.signature_status_9, item.is_authorizer_9) : ''}}
                </template> 
                <template v-slot:item.signature_status_10="{ item }">
                    {{item.signature_status_10 ? getSignatureStatus(item.signature_status_10, item.is_authorizer_10) : ''}}
                </template> 
            </v-data-table>
        </v-container>
        <v-container>
            <all-list-display-item-setting v-model="itemSettingDialog" :itemSettingDialog="itemSettingDialog" :displaySetting="displaySetting" @parent-event="setDisplaySetting"></all-list-display-item-setting>
        </v-container>
    </v-container>
</template>

<script>
    import moment from 'moment';
    import VueJsonToCsv from "vue-json-to-csv";
    import AllListDisplayItemSetting from "./AllListDisplayItemSetting";
    import page_offset_limit_component from '../../components/common/PageOffsetLimitComponent.vue';
    import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
    import { dateformatMixin } from '../../mixins/dateformatMixin.js';
    export default {
        props: {
            agreement_list: Array,
            user: Object,
            company: Object,
            navi : [],
        },
        data() {
            return {
                panel: [0, 1],
                statusIndex: 0,
                methodIndex: 0,
                iconIndex:0,
                itemSettingDialog:false,
                total:0,
                searchItem: {
                    authorizer:true,
                    signature:true,
                    conclusion:true,
                    rejection:true,
                    error:true,
                    sign_long:true,
                    sign_light_timestamp:true,
                    sign_light:true,
                    sender_companies: [],
                    sender_my_company:false,
                    sender_other_company:false,
                    senders:[],
                    charge:false,
                    other_charge:false,
                    next_checkers:[],
                    i_confirmer:false,
                    other_confirmer:false,
                    to_contract_companies: [],
                    keyword:'',
                },
                senderCompanies:[],
                senders:[],
                toContractCompanies:[],
                nextChecker:[],
                indexInfo: {
                    page: 1, // ページ数
                    pageCount: 0, // 最大ページ数
                    itemsPerPage: 10, // 1ページあたりの項目数
                },
                csvData: [],
                labels: {
                    'object_id' : { title: "管理ID" },
                    'contract_name' : { title: "件名" },
                    'contract_status' : { title: "状態" },
                    'signature_method' : { title: "署名方式" },
                    'close_date' : { title: "締結/却下日時" },
                    'sender_user_name' : { title: "送信者" },
                    'sender_email_address' : { title: "送信者メールアドレス" },
                    'sender_company_name' : { title: "送信者企業" },
                    'sender_send_datetime' : { title: "送信日時" },
                    'next_remind_send_datetime' : { title: "リマインド日時" },
                    'antecedent_confirm_user_name' : { title: "前の確認者" },
                    'antecedent_confirm_email_address' : { title: "前の確認者メールアドレス" },
                    'antecedent_confirm_company_name' : { title: "前の確認者企業" },
                    'antecedent_confirm_signature_datetime' : { title: "前の確認日時" },
                    'antecedent_confirm_signature_status' : { title: "前の確認状況" },
                    'next_confirm_user_name' : { title: "次の確認者" },
                    'next_confirm_email_address' : { title: "次の確認者メールアドレス" },
                    'next_confirm_company_name' : { title: "次の確認者企業" },
                    'next_confirm_role' : { title: "次の確認者役割" },
                    'next_confirm_signature_status' : { title: "次の確認者開封状況" },
                    'next_confirm_expire' : { title: "確認期限" },
                    'last_confirm_user_name' : { title: "最終署名者" },
                    'last_confirm_email_address' : { title: "最終署名者メールアドレス" },
                    'last_confirm_company_name' : { title: "最終署名者企業" },
                    'last_confirm_signature_datetime' : { title: "最終署名日時" },
                    
                    'destination_user_name_2' : { title: "関係者2" },
                    'destination_email_address_2' : { title: "関係者2メールアドレス" },
                    'destination_company_name_2' : { title: "関係者2企業" },
                    'destination_role_2' : { title: "関係者2役割" },
                    'signature_datetime_2' : { title: "関係者2確認日時" },
                    'signature_status_2' : { title: "関係者2確認状況" },
                    
                    'destination_user_name_3' : { title: "関係者3" },
                    'destination_email_address_3' : { title: "関係者3メールアドレス" },
                    'destination_company_name_3' : { title: "関係者3企業" },
                    'destination_role_3' : { title: "関係者3役割" },
                    'signature_datetime_3' : { title: "関係者3確認日時" },
                    'signature_status_3' : { title: "関係者3確認状況" },
                    
                    'destination_user_name_4' : { title: "関係者4" },
                    'destination_email_address_4' : { title: "関係者4メールアドレス" },
                    'destination_company_name_4' : { title: "関係者4企業" },
                    'destination_role_4' : { title: "関係者4役割" },
                    'signature_datetime_4' : { title: "関係者4確認日時" },
                    'signature_status_4' : { title: "関係者4確認状況" },
                    
                    'destination_user_name_5' : { title: "関係者5" },
                    'destination_email_address_5' : { title: "関係者5メールアドレス" },
                    'destination_company_name_5' : { title: "関係者5企業" },
                    'destination_role_5' : { title: "関係者5役割" },
                    'signature_datetime_5' : { title: "関係者5確認日時" },
                    'signature_status_5' : { title: "関係者5確認状況" },
                    
                    'destination_user_name_6' : { title: "関係者6" },
                    'destination_email_address_6' : { title: "関係者6メールアドレス" },
                    'destination_company_name_6' : { title: "関係者6企業" },
                    'destination_role_6' : { title: "関係者6役割" },
                    'signature_datetime_6' : { title: "関係者6確認日時" },
                    'signature_status_6' : { title: "関係者6確認状況" },
                    
                    'destination_user_name_7' : { title: "関係者7" },
                    'destination_email_address_7' : { title: "関係者7メールアドレス" },
                    'destination_company_name_7' : { title: "関係者7企業" },
                    'destination_role_7' : { title: "関係者7役割" },
                    'signature_datetime_7' : { title: "関係者7確認日時" },
                    'signature_status_7' : { title: "関係者7確認状況" },
                    
                    'destination_user_name_8' : { title: "関係者8" },
                    'destination_email_address_8' : { title: "関係者8メールアドレス" },
                    'destination_company_name_8' : { title: "関係者8企業" },
                    'destination_role_8' : { title: "関係者8役割" },
                    'signature_datetime_8' : { title: "関係者8確認日時" },
                    'signature_status_8' : { title: "関係者8確認状況" },
                    
                    'destination_user_name_9' : { title: "関係者9" },
                    'destination_email_address_9' : { title: "関係者9メールアドレス" },
                    'destination_company_name_9' : { title: "関係者9企業" },
                    'destination_role_9' : { title: "関係者9役割" },
                    'signature_datetime_9' : { title: "関係者9確認日時" },
                    'signature_status_9' : { title: "関係者9確認状況" },
                    
                    'destination_user_name_10' : { title: "関係者10" },
                    'destination_email_address_10' : { title: "関係者10メールアドレス" },
                    'destination_company_name_10' : { title: "関係者10企業" },
                    'destination_role_10' : { title: "関係者10役割" },
                    'signature_datetime_10' : { title: "関係者10確認日時" },
                    'signature_status_10' : { title: "関係者10確認状況" },

                },
                displaySetting: {
                    'contract_name' : true,
                    'contract_status' : true,
                    'signature_method' : true,
                    'close_date' : false,
                    'sender_user_name' : true,
                    'sender_email_address' : false,
                    'sender_company_name' : true,
                    'sender_send_datetime' : true,
                    'next_remind_send_datetime' : true,
                    'antecedent_confirm_user_name' : false,
                    'antecedent_confirm_email_address' : false,
                    'antecedent_confirm_company_name' : false,
                    'antecedent_confirm_signature_datetime' : false,
                    'antecedent_confirm_signature_status' : false,
                    'next_confirm_user_name' : true,
                    'next_confirm_email_address' : false,
                    'next_confirm_company_name' : true,
                    'next_confirm_role' : false,
                    'next_confirm_expire' : false,
                    'last_confirm_user_name' : true,
                    'last_confirm_email_address' : false,
                    'last_confirm_company_name' : true,
                    'last_confirm_signature_datetime' : false,
                    'destination_user_name_2' : false,
                    'destination_email_address_2' : false,
                    'destination_company_name_2' : false,
                    'destination_role_2' : false,
                    'signature_datetime_2' : false,
                    'signature_status_2' : false,
                    'destination_user_name_3' : false,
                    'destination_email_address_3' : false,
                    'destination_company_name_3' : false,
                    'destination_role_3' : false,
                    'signature_datetime_3' : false,
                    'signature_status_3' : false,
                    'destination_user_name_4' : false,
                    'destination_email_address_4' : false,
                    'destination_company_name_4' : false,
                    'destination_role_4' : false,
                    'signature_datetime_4' : false,
                    'signature_status_4' : false,
                    'destination_user_name_5' : false,
                    'destination_email_address_5' : false,
                    'destination_company_name_5' : false,
                    'destination_role_5' : false,
                    'signature_datetime_5' : false,
                    'signature_status_5' : false,
                    'destination_user_name_6' : false,
                    'destination_email_address_6' : false,
                    'destination_company_name_6' : false,
                    'destination_role_6' : false,
                    'signature_datetime_6' : false,
                    'signature_status_6' : false,
                    'destination_user_name_7' : false,
                    'destination_email_address_7' : false,
                    'destination_company_name_7' : false,
                    'destination_role_7' : false,
                    'signature_datetime_7' : false,
                    'signature_status_7' : false,
                    'destination_user_name_8' : false,
                    'destination_email_address_8' : false,
                    'destination_company_name_8' : false,
                    'destination_role_8' : false,
                    'signature_datetime_8' : false,
                    'signature_status_8' : false,
                    'destination_user_name_9' : false,
                    'destination_email_address_9' : false,
                    'destination_company_name_9' : false,
                    'destination_role_9' : false,
                    'signature_datetime_9' : false,
                    'signature_status_9' : false,
                    'destination_user_name_10' : false,
                    'destination_email_address_10' : false,
                    'destination_company_name_10' : false,
                    'destination_role_10' : false,
                    'signature_datetime_10' : false,
                    'signature_status_10' : false,
                },
           };
        },
        mixins:[
            signatureMethodMixin,
            dateformatMixin,
        ],
        created() {
            let displaySetting = JSON.parse(window.localStorage.getItem('all_list_display_setting'));
            if(displaySetting){
                this.displaySetting = Object.assign(this.displaySetting, displaySetting);
            }
            
            let searchItem = JSON.parse(window.localStorage.getItem('all_list_search_item'));
            if(searchItem){
                this.searchItem = Object.assign(this.searchItem, searchItem);
            }
            
            let senderCompanies = new Array;
            let senderEmail = new Array;
            let nextEmail = new Array;
            let toContractCompanies = new Array;
            
            let senderExist = false;
            let nextExist = false;
            
            this.agreement_list.forEach((agreement) => {
                if(agreement.sender_company_name && agreement.sender_company_name.trim()
                    && senderCompanies.indexOf(agreement.sending_company_id) < 0 ){
                    senderCompanies.push(agreement.sending_company_id);  
                    this.senderCompanies.push({
                        'company_id':agreement.sending_company_id,
                        'company_name':agreement.sender_company_name,
                    });
                }
                
                if(agreement.sender_email_address
                    && senderEmail.indexOf(agreement.sender_email_address) < 0 ){
                    senderEmail.push(agreement.sender_email_address);    
                    this.senders.push({
                        'sender_user_name':agreement.sender_user_name,
                        'sender_email_address':agreement.sender_email_address,
                    });
                    
                    if(!senderExist && agreement.sender_email_address == this.user.email){
                        senderExist = true;
                    }
                }

                if(agreement.next_confirm_user_name && agreement.next_confirm_user_name.trim()
                    && nextEmail.indexOf(agreement.next_confirm_email_address) < 0 ){
                    nextEmail.push(agreement.next_confirm_email_address);     
                    this.nextChecker.push({
                        'next_confirm_user_name':agreement.next_confirm_user_name,
                        'next_confirm_email_address':agreement.next_confirm_email_address,
                    });
                    
                    if(!nextExist && agreement.next_confirm_email_address == this.user.email){
                        nextExist = true;
                    }
                }

                if(agreement.to_contract_company_name_list){
                    toContractCompanies = [...toContractCompanies, ...agreement.to_contract_company_name_list];
                }
            });
            
            if(!senderExist){
                this.senders.push({
                    'sender_user_name':this.user.name,
                    'sender_email_address':this.user.email,
                });
            }
            
            if(!nextExist){
                this.nextChecker.push({
                    'next_confirm_user_name':this.user.name,
                    'next_confirm_email_address':this.user.email,
                });
            }

            if (toContractCompanies){
                this.toContractCompanies = Array.from(new Set(toContractCompanies));
            }
        },
        computed: {
            csvTitle() {
                return "dxsign_agreement_list";
            },
            items(){
                return this.agreement_list.map(agreement => {
                    if (agreement.contract_status != 'rejection' && agreement.next_confirm_email_address == this.user.email){
                        agreement.next_confirm_order = true;
                    } else {
                        agreement.next_confirm_order = false;
                    }
                    if (agreement.contract_status != 'rejection' && agreement.contract_error_status == 1){
                        agreement.contract_status = 'error';
                    }
                    return agreement;
                });
            },
            filterHeaders(){
                let headers = new Array;
                headers.push({
                    text: "",
                    value:'next_confirm_order',
                    width: "5%",
                    sortable: true,
                });
                if(this.displaySetting.contract_name){
                    headers.push({
                        text: "件名",
                        value:'contract_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.contract_status){
                    headers.push({
                        text: "状態",
                        value:'contract_status',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.signature_method){
                    headers.push({
                        text: "署名方式",
                        value:'signature_method',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.close_date){
                    headers.push({
                        text: "締結/却下日時",
                        value:'close_date',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.sender_user_name){
                    headers.push({
                        text: "送信者",
                        value:'sender_user_name',
                    });
                }
                if(this.displaySetting.sender_email_address){
                    headers.push({
                        text: "送信者\r\nメールアドレス",
                        value:'sender_email_address',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.sender_company_name){
                    headers.push({
                        text: "送信者\r\n企業",
                        value:'sender_company_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.sender_send_datetime){
                    headers.push({
                        text: "送信日時",
                        value:'sender_send_datetime',
                        sortable: true,
                    });
                }

                
                if(this.displaySetting.next_remind_send_datetime){
                    headers.push({
                        text: "リマインド日時",
                        value:'next_remind_send_datetime',
                        sortable: true,
                    });
                }

                
                
                if(this.displaySetting.antecedent_confirm_user_name){
                    headers.push({
                        text: "前の確認者",
                        value:'antecedent_confirm_user_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.antecedent_confirm_email_address){
                    headers.push({
                        text: "前の確認者\r\nメールアドレス",
                        value:'antecedent_confirm_email_address',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.antecedent_confirm_company_name){
                    headers.push({
                        text: "前の確認者\r\n企業",
                        value:'antecedent_confirm_company_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.antecedent_confirm_signature_datetime){
                    headers.push({
                        text: "前の確認日時",
                        value:'antecedent_confirm_signature_datetime',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.antecedent_confirm_signature_status){
                    headers.push({
                        text: "前の確認状況",
                        value:'antecedent_confirm_signature_status',
                        sortable: false,
                    });
                }
                
                if(this.displaySetting.next_confirm_user_name){
                    headers.push({
                        text: "次の確認者",
                        value:'next_confirm_user_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.next_confirm_email_address){
                    headers.push({
                        text: "次の確認者\r\nメールアドレス",
                        value:'next_confirm_email_address',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.next_confirm_company_name){
                    headers.push({
                        text: "次の確認者\r\n企業",
                        value:'next_confirm_company_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.next_confirm_role){
                    headers.push({
                        text: "次の確認者\r\n役割",
                        value:'next_confirm_role',
                        sortable: false,
                    });
                }
                
                if(this.displaySetting.next_confirm_opening_status){
                    headers.push({
                        text: "次の確認者\r\n開封状況",
                        value:'next_confirm_opening_status',
                        sortable: false,
                    });
                }
                
                if(this.displaySetting.next_confirm_expire){
                    headers.push({
                        text: "確認期限",
                        value:'next_confirm_expire',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.last_confirm_user_name){
                    headers.push({
                        text: "最終署名者",
                        value:'last_confirm_user_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.last_confirm_email_address){
                    headers.push({
                        text: "最終署名者\r\nメールアドレス",
                        value:'last_confirm_email_address',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.last_confirm_company_name){
                    headers.push({
                        text: "最終署名者\r\n企業",
                        value:'last_confirm_company_name',
                        sortable: true,
                    });
                }
                
                if(this.displaySetting.last_confirm_signature_datetime){
                    headers.push({
                        text: "最終署名日時",
                        value:'last_confirm_signature_datetime',
                        sortable: true,
                    });
                }
                
                for (let i = 2; i <= 10; i++){
                    let key = 'destination_user_name_' + i;
                    if(this.displaySetting[key]){
                        headers.push({
                            text: "関係者" + i + "\r\n氏名",
                            value: key,
                            sortable: true,
                        });
                    }
                    key = 'destination_email_address_' + i;
                    if(this.displaySetting[key]){
                        headers.push({
                            text: "関係者" + i + "\r\nメールアドレス",
                            value: key,
                            sortable: true,
                        });
                    }
                    key = 'destination_company_name_' + i;
                    if(this.displaySetting[key]){
                        headers.push({
                            text: "関係者" + i + "\r\n企業",
                            value: key,
                            sortable: true,
                        });
                    }
                    key = 'destination_role_' + i;
                    if(this.displaySetting[key]){
                        headers.push({
                            text: "関係者" + i + "\r\n役割",
                            value: key,
                            sortable: false,
                        });
                    }
                    key = 'signature_datetime_' + i;
                    if(this.displaySetting[key]){
                        headers.push({
                            text: "関係者" + i + "\r\n確認日時",
                        });
                    }
                    key = 'signature_status_' + i;
                    if(this.displaySetting[key]){
                        headers.push({
                            text: "関係者" + i + "\r\n確認状況",
                            value: key,
                            sortable: true,
                        });
                    }
                }
                
                return headers;
            },
            
            filterItems() {
                let searchItem = this.searchItem;
                let checked = false;
                let items = this.items.filter(function(item) {
                    if (!item) {
                        return false;
                    }
                    if(searchItem.authorizer || searchItem.signature || searchItem.conclusion || searchItem.rejection || searchItem.error){
                        checked = false;
                        if(searchItem.authorizer && 'authorizer' == item.contract_status){
                            checked = true;
                        }else if(searchItem.signature && 'signature' == item.contract_status){
                            checked = true;
                        }else if(searchItem.conclusion && 'conclusion' == item.contract_status){
                            checked = true;
                        }else if(searchItem.rejection && 'rejection' == item.contract_status){
                            checked = true;
                        }else if(searchItem.error && 'error' == item.contract_status){
                            checked = true;
                        }
                        
                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.sign_long || searchItem.sign_light_timestamp || searchItem.sign_light){
                        checked = false;
                        if(searchItem.sign_long && 'sign_long' == item.signature_method){
                            checked = true;
                        }else if(searchItem.sign_light_timestamp && 'sign_light_timestamp' == item.signature_method){
                            checked = true;
                        }else if(searchItem.sign_light && 'sign_light' == item.signature_method){
                            checked = true;
                        }
                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.sender_companies.length > 0){
                        checked = false;
                        searchItem.sender_companies.forEach((company) => {
                            if(item.sending_company_id == company.company_id){
                                checked = true;
                            }
                        });
                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.senders.length > 0){
                        checked = false;
                        searchItem.senders.forEach((sender) => {
                            if(item.sender_email_address.indexOf(sender.sender_email_address) !== -1){
                                checked = true;
                            }
                        });
                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.next_checkers.length > 0){
                        checked = false;
                        searchItem.next_checkers.forEach((checkers) => {
                            if(item.next_confirm_email_address.indexOf(checkers.next_confirm_email_address) !== -1){
                                checked = true;
                            }
                        });
                        if(!checked){
                            return checked;
                        }
                    }

                    if(searchItem.to_contract_companies.length > 0){
                        checked = false;
                        searchItem.to_contract_companies.forEach((to_contract_company) => {
                            if(item.to_contract_company_name_list.indexOf(to_contract_company) !== -1){
                                checked = true;
                            }
                        });
                        
                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.keyword){
                        let splitedKeyword = searchItem.keyword.split(/ |　/g);
                        checked = splitedKeyword.every(keyword => {
                            if(item.to_destination_user_name_list.findIndex((name) => (name?.indexOf(keyword) > -1)) > -1){
                                return true;
                            }else if(item.to_destination_company_name_list?.findIndex((name) => (name?.indexOf(keyword) > -1)) > -1){
                                return true;
                            }else if(item.contract_name?.indexOf(keyword) > -1) {
                                return true;
                            }
                            return false;
                        });
                        if(!checked){
                            return checked;
                        }
                    }
                    return true;
                });
                
                window.localStorage.setItem('all_list_search_item', JSON.stringify(searchItem));
                this.total = items ? items.length : 0;
                return items;
            }
        },
        methods: {
            exportFiles() {
                let regExp = /"/g;
                this.csvData = [];
                this.items.forEach((agreement) => {
                    this.csvData.push({
                        'object_id' : agreement.object_id,
                        'contract_name' : agreement.contract_name ? agreement.contract_name.replace(regExp, '""') : '',
                        'contract_status' : this.getContractStatus(agreement),
                        'signature_method' : this.getSignatureMethodText(agreement.signature_method),
                        'close_date' : this.weekTimeFormat(agreement.close_date),
                        
                        'sender_user_name' : agreement.sender_user_name ? agreement.sender_user_name.replace(regExp, '""') : '',
                        'sender_email_address' : agreement.sender_email_address,
                        'sender_company_name' : agreement.sender_company_name ? agreement.sender_company_name.replace(regExp, '""') : '',
                        'sender_send_datetime' : this.weekTimeFormat(agreement.sender_send_datetime),
                        'next_remind_send_datetime' : this.weekTimeFormat(agreement.next_remind_send_datetime),
                        
                        'antecedent_confirm_user_name' : agreement.antecedent_confirm_user_name ? agreement.antecedent_confirm_user_name.replace(regExp, '""') : '',
                        'antecedent_confirm_email_address' : agreement.antecedent_confirm_email_address,
                        'antecedent_confirm_company_name' : agreement.antecedent_confirm_company_name ? agreement.antecedent_confirm_company_name.replace(regExp, '""') : '',
                        'antecedent_confirm_signature_datetime' : this.weekTimeFormat(agreement.antecedent_confirm_signature_datetime),
                        'antecedent_confirm_signature_status' : this.getSignatureStatus(agreement.antecedent_confirm_signature_status, agreement.antecedent_confirm_is_authorizer),
                        
                        'next_confirm_user_name' : agreement.next_confirm_user_name ? agreement.next_confirm_user_name.replace(regExp, '""') : '',
                        'next_confirm_email_address' : agreement.next_confirm_email_address,
                        'next_confirm_company_name' : agreement.next_confirm_company_name ? agreement.next_confirm_company_name.replace(regExp, '""') : '',
                        'next_confirm_role' : this.getIsAuthorizer(agreement.next_confirm_is_authorizer),
                        'next_confirm_signature_status' : this.getSignatureStatus(agreement.next_confirm_signature_status, agreement.next_confirm_is_authorizer),
                        'next_confirm_expire' : this.weekTimeFormat(agreement.next_confirm_expire),
                        
                        'last_confirm_user_name' : agreement.last_confirm_user_name ? agreement.last_confirm_user_name.replace(regExp, '""') : '',
                        'last_confirm_email_address' : agreement.last_confirm_email_address,
                        'last_confirm_company_name' : agreement.last_confirm_company_name ? agreement.last_confirm_company_name.replace(regExp, '""') : '',
                        'last_confirm_signature_datetime' : this.weekTimeFormat(agreement.last_confirm_signature_datetime),
                        
                        'destination_user_name_2' : agreement.destination_user_name_2 ? agreement.destination_user_name_2.replace(regExp, '""') : '',
                        'destination_email_address_2' : agreement.destination_email_address_2  ?? '',
                        'destination_company_name_2' : agreement.destination_company_name_2 ? agreement.destination_company_name_2.replace(regExp, '""') : '',
                        'destination_role_2' : this.getIsAuthorizer(agreement.is_authorizer_2),
                        'signature_datetime_2' : this.weekTimeFormat(agreement.signature_datetime_2),
                        'signature_status_2' : agreement.signature_status_2 ? this.getSignatureStatus(agreement.signature_status_2, agreement.is_authorizer_2) : '',
                        
                        'destination_user_name_3' : agreement.destination_user_name_3 ? agreement.destination_user_name_3.replace(regExp, '""') : '',
                        'destination_email_address_3' : agreement.destination_email_address_3 ?? '',
                        'destination_company_name_3' : agreement.destination_company_name_3 ? agreement.destination_company_name_3.replace(regExp, '""') : '',
                        'destination_role_3' : this.getIsAuthorizer(agreement.is_authorizer_3),
                        'signature_datetime_3' : this.weekTimeFormat(agreement.signature_datetime_3),
                        'signature_status_3' : agreement.signature_status_3 ? this.getSignatureStatus(agreement.signature_status_3, agreement.is_authorizer_3) : '',
                        
                        'destination_user_name_4' : agreement.destination_user_name_4 ? agreement.destination_user_name_4.replace(regExp, '""') : '',
                        'destination_email_address_4' : agreement.destination_email_address_4 ?? '',
                        'destination_company_name_4' : agreement.destination_company_name_4 ? agreement.destination_company_name_4.replace(regExp, '""') : '',
                        'destination_role_4' : this.getIsAuthorizer(agreement.is_authorizer_4),
                        'signature_datetime_4' : this.weekTimeFormat(agreement.signature_datetime_4),
                        'signature_status_4' : agreement.signature_status_4 ? this.getSignatureStatus(agreement.signature_status_4, agreement.is_authorizer_4) : '',
                        
                        'destination_user_name_5' : agreement.destination_user_name_5 ? agreement.destination_user_name_5.replace(regExp, '""') : '',
                        'destination_email_address_5' : agreement.destination_email_address_5 ?? '',
                        'destination_company_name_5' : agreement.destination_company_name_5 ? agreement.destination_company_name_5.replace(regExp, '""') : '',
                        'destination_role_5' : this.getIsAuthorizer(agreement.is_authorizer_5),
                        'signature_datetime_5' : this.weekTimeFormat(agreement.signature_datetime_5),
                        'signature_status_5' : agreement.signature_status_5 ? this.getSignatureStatus(agreement.signature_status_5, agreement.is_authorizer_5) : '',
                        
                        'destination_user_name_6' : agreement.destination_user_name_6 ? agreement.destination_user_name_6.replace(regExp, '""') : '',
                        'destination_email_address_6' : agreement.destination_email_address_6 ?? '',
                        'destination_company_name_6' : agreement.destination_company_name_6 ? agreement.destination_company_name_6.replace(regExp, '""') : '',
                        'destination_role_6' : this.getIsAuthorizer(agreement.is_authorizer_6),
                        'signature_datetime_6' : this.weekTimeFormat(agreement.signature_datetime_6),
                        'signature_status_6' : agreement.signature_status_6 ? this.getSignatureStatus(agreement.signature_status_6, agreement.is_authorizer_6) : '',
                        
                        'destination_user_name_7' : agreement.destination_user_name_7 ? agreement.destination_user_name_7.replace(regExp, '""') : '',
                        'destination_email_address_7' : agreement.destination_email_address_7 ?? '',
                        'destination_company_name_7' : agreement.destination_company_name_7 ? agreement.destination_company_name_7.replace(regExp, '""') : '',
                        'destination_role_7' : this.getIsAuthorizer(agreement.is_authorizer_7),
                        'signature_datetime_7' : this.weekTimeFormat(agreement.signature_datetime_7),
                        'signature_status_7' : agreement.signature_status_7 ? this.getSignatureStatus(agreement.signature_status_7, agreement.is_authorizer_7) : '',
                        
                        'destination_user_name_8' : agreement.destination_user_name_8 ? agreement.destination_user_name_8.replace(regExp, '""') : '',
                        'destination_email_address_8' : agreement.destination_email_address_8 ?? '',
                        'destination_company_name_8' : agreement.destination_company_name_8 ? agreement.destination_company_name_8.replace(regExp, '""') : '',
                        'destination_role_8' : this.getIsAuthorizer(agreement.is_authorizer_8),
                        'signature_datetime_8' : this.weekTimeFormat(agreement.signature_datetime_8),
                        'signature_status_8' : agreement.signature_status_8 ? this.getSignatureStatus(agreement.signature_status_8, agreement.is_authorizer_8) : '',
                        
                        'destination_user_name_9' : agreement.destination_user_name_9 ? agreement.destination_user_name_9.replace(regExp, '""') : '',
                        'destination_email_address_9' : agreement.destination_email_address_9 ?? '',
                        'destination_company_name_9' : agreement.destination_company_name_9 ? agreement.destination_company_name_9.replace(regExp, '""') : '',
                        'destination_role_9' : this.getIsAuthorizer(agreement.is_authorizer_9),
                        'signature_datetime_9' : this.weekTimeFormat(agreement.signature_datetime_9),
                        'signature_status_9' : agreement.signature_status_9 ? this.getSignatureStatus(agreement.signature_status_9, agreement.is_authorizer_9) : '',
                        
                        'destination_user_name_10' : agreement.destination_user_name_10 ? agreement.destination_user_name_10.replace(regExp, '""') : '',
                        'destination_email_address_10' : agreement.destination_email_address_10 ?? '',
                        'destination_company_name_10' : agreement.destination_company_name_10 ? agreement.destination_company_name_10.replace(regExp, '""') : '',
                        'destination_role_10' : this.getIsAuthorizer(agreement.is_authorizer_10),
                        'signature_datetime_10' : this.weekTimeFormat(agreement.signature_datetime_10),
                        'signature_status_10' : agreement.signature_status_10 ? this.getSignatureStatus(agreement.signature_status_10, agreement.is_authorizer_10) : '',
                    });
                });
            },
            searchSenderMyCompany(){
                this.searchItem.sender_other_company = false;
                this.searchItem.sender_my_company = this.searchItem.sender_my_company ? false : true;
                if(this.searchItem.sender_my_company){
                    this.searchItem.sender_companies = new Array;
                    
                    this.searchItem.sender_companies.push({
                        'company_id':this.company.id,
                        'company_name':this.company.name, 
                    });

                }else{
                    this.searchItem.sender_companies = this.searchItem.sender_companies.filter(function(item) {
                        return item.company_id !== this.company.id;
                    }, this);
                }
            },
            searchSenderOtherCompany(){
                this.searchItem.sender_my_company = false;
                this.searchItem.sender_other_company = this.searchItem.sender_other_company ? false : true;
                if(this.searchItem.sender_other_company){
                    this.searchItem.sender_companies = this.senderCompanies.filter(function(item) {
                        return item.company_id !== this.company.id;
                    }, this);
                }else{
                    this.searchItem.sender_companies = this.searchItem.sender_companies.filter(function(item) {
                        return item.company_id === this.company.id;
                    }, this);
                }
            },
            searchCharge(){
                this.searchItem.other_charge = false;
                this.searchItem.charge = this.searchItem.charge ? false : true;
                if(this.searchItem.charge){
                    this.searchItem.senders = new Array;
                    this.searchItem.senders.push({
                        'sender_user_name':this.user.name,
                        'sender_email_address':this.user.email,
                    });

                }else{
                    this.searchItem.senders = this.searchItem.senders.filter(function(item) {
                        return item.sender_email_address !== this.user.email;
                    }, this);
                }
            },
            searchOtherCharge(){
                this.searchItem.charge = false;
                this.searchItem.other_charge = this.searchItem.other_charge ? false : true;
                if(this.searchItem.other_charge){
                    this.searchItem.senders = this.senders.filter(function(item) {
                        return item.sender_email_address !== this.user.email;
                    }, this);
                }else{
                    this.searchItem.senders = this.searchItem.senders.filter(function(item) {
                        return item.sender_email_address === this.user.email;
                    }, this);
                }
            },
            searchIConfirmer(){
                this.searchItem.other_confirmer = false;
                this.searchItem.i_confirmer = this.searchItem.i_confirmer ? false : true;
                if(this.searchItem.i_confirmer){
                    this.searchItem.next_checkers = new Array;
                    this.searchItem.next_checkers.push({
                        'next_confirm_user_name':this.user.name,
                        'next_confirm_email_address':this.user.email,
                    });

                }else{
                    let next_checkers = this.searchItem.next_checkers.filter(function(item) {
                        return item.next_confirm_email_address !== this.user.email;
                    }, this);
                    this.searchItem.next_checkers = next_checkers;
                }
            },
            searchOtherConfirmer(){
                this.searchItem.i_confirmer = false;
                this.searchItem.other_confirmer = this.searchItem.other_confirmer ? false : true;
                if(this.searchItem.other_confirmer){
                    this.searchItem.next_checkers = this.nextChecker.filter(function(item) {
                        return item.next_confirm_email_address !== this.user.email;
                    }, this);
                }else{
                    this.searchItem.next_checkers = this.searchItem.next_checkers.filter(function(item) {
                        return item.next_confirm_email_address === this.user.email;
                    }, this);
                }
            },
            getSignatureStatus(signatureStatus, isAuthorizer){
                if(signatureStatus == 0){
                    return '未承認';
                }else if(signatureStatus == 1 && isAuthorizer == 1){
                    return '承認済み';
                }else if(signatureStatus == 1 && isAuthorizer == 0){
                    return '署名済み';
                }else if(signatureStatus == 2){
                    return '却下';
                }else if(signatureStatus == 3){
                    return '転送';
                }
            },
            getOpeningStatus(openingStatus){
                if(openingStatus == 1){
                    return '未開封';
                }else if(openingStatus == 2){
                    return '開封済';
                }else if(openingStatus == 3){
                    return '送信エラー';
                }
            },
            getContractStatus(item){
                if (item.contract_status == 'authorizer'){
                    return '承認待ち';
                }else if(item.contract_status == 'signature'){
                    return '署名待ち';
                }else if(item.contract_status == 'conclusion'){
                    return '締結済み';
                }else if(item.contract_status == 'rejection'){
                    return '却下';
                }else if(item.contract_status == 'error'){
                    return 'エラー';
                }
            },
            getIsAuthorizer(isAuthorizer){
                if(isAuthorizer == 0){
                    return '署名者';
                }else if(isAuthorizer == 1){
                    return '承認者';
                }
                return '';
            },
            setDisplaySetting(displaySetting){
                this.displaySetting = displaySetting;
            },
            itemAction(item) {
                // 契約クリック時
                window.location.href = "/documents/document-management/summary/" + item.object_id;
            },
        },
        components: {
            VueJsonToCsv,
            AllListDisplayItemSetting,
            page_offset_limit_component,
        },
    };
</script>

<style scoped lang="scss">

.search-container{
    max-width: 100%!important;
}

.title{
    font-size: 1.5rem !important;
    font-weight: bold;
}

.search-title{
    font-size: 13px !important;
}

::v-deep .v-expansion-panels {
    width: 99% !important;
}

::v-deep .v-expansion-panel-header__icon{
    margin-left: inherit !important;
}

::v-deep .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 0px !important;
}

::v-deep .v-expansion-panel-content__wrap {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.search-section ::v-deep .v-btn{
    height: 26px !important;
}

.search-section ::v-deep .v-btn.lightblue{
    background-color: white !important;
    border-color: white !important;
}

.search-section ::v-deep .v-btn:hover{
    background-color: #78bcf3!important;
    border-color: #78bcf3!important;
    color:white;
}
.search-section .sear{
    display:inline-table;
}

::v-deep .v-data-table-header > tr > th{
    white-space: pre;
}
.search-section ::v-deep .v-btn.blur{
    background-color: #2196f3!important;
    border-color: #2196f3!important;
    color:white;
}
.search-section ::v-deep .v-btn__content{
    font-size: 13px !important;
}
.search-status{
    font-weight: bold;
    font-size: 13px;
}

::v-deep .csv-btn.v-btn{
    height: 25px !important;
}

::v-deep .setting-btn.v-btn{
    height: 25px !important;
}
::v-deep .csv-btn > .v-btn__content {
    font-size: 13px !important;
}

::v-deep .setting-btn > .v-btn__content {
    font-size: 13px !important;
}

.contents{
    margin-top:20px;
}
::v-deep .v-pagination__navigation{
    height: 25px !important;
    width: 25px !important;
}
::v-deep .v-pagination__item{
    height: 25px !important;
    width: 25px !important;
    min-width: 25px !important;
    font-size: 1.2rem !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 1.2rem !important;
    padding-left: 8px;
    padding-right: 8px;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 1.2rem !important;
    padding-left: 8px;
    padding-right: 8px;
    height: 40px;
}
::v-deep .page-offset-col{
    padding-top: 32px;
}
.icon-bubble {
    display: none;
    width: 100px;
    position: absolute;
    top: -30px;
    left: -22px;
    padding: 4px;
    text-align: center;
    border-radius: 5px;
    background: #3c4043;
    color: #fff;
    font-weight: bold;
    font-size: 12px !important;
}
.icon-bubble:after {
    position: absolute;
    width: 0;
    height: 0;
    left: 14px;
    bottom: -15px;
    margin-left: 10px;
    border: solid transparent;
    border-color: rgba(51, 204, 153, 0);
    border-top-color: #3c4043;
    border-width: 10px;
    pointer-events: none;
    content: " ";
}

.icon-item{
    position: relative;
    padding: 0;
    display: inline-block;
}
::v-deep .icon-item .v-list-item__icon{
    margin-left: 0px !important;
}
::v-deep .icon-item .theme--light.v-icon:hover + .icon-bubble {
      display: block;
}

::v-deep .v-col-icon{
   flex-grow: 0 !important;
}


.searchicon{
    color:#2196f3;
}

.authorizer{
    background-color: #FFB300;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
.signature{
    background-color: #039BE5;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
.conclusion{
    background-color: #7CB342;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
.rejection{
    background-color: gray;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
.error{
    background-color: #EF5350;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}

.white-space-nowrap{
    max-width: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.min-width250{
    min-width: 250px;
}
.sc-section{
    position: relative;
    top: auto;
    left: 135px;
}

@media screen and (max-width: 1881px) {
    .sc-section{
        position: relative;
        top: auto;
        left: -9px;
    }
}

@media screen and (max-width: 1263px) {
    .sc-section{
        position: relative;
        top: auto;
        left: 141px;
    }
}
</style>